import { render } from "./ignore-view-table.vue?vue&type=template&id=bb4449a6&scoped=true&ts=true"
import script from "./ignore-view-table.vue?vue&type=script&lang=ts"
export * from "./ignore-view-table.vue?vue&type=script&lang=ts"

import "./ignore-view-table.vue?vue&type=style&index=0&id=bb4449a6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4449a6"]])

export default __exports__